import { useMutation } from "@tanstack/react-query";

import { AttendeeInput, updateAttendee } from "@/api/headlinr";

interface useUpdateAttendeeProps {
  onError: (error: any) => void;
  onSuccess: (data: any) => void;
}
const useUpdateAttendee = ({ onError, onSuccess }: useUpdateAttendeeProps) => {
  return useMutation({
    mutationFn: ({ id, attendee }: { id: number; attendee: AttendeeInput }) => {
      return updateAttendee(id, attendee);
    },
    onError: (error) => {
      onError(error);
    },
    onSuccess: (data) => {
      onSuccess(data);
    },
  });
};

export default useUpdateAttendee;
